/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Register
 */
export interface Register {
    /**
     * 
     * @type {string}
     * @memberof Register
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof Register
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Register
     */
    password1: string;
    /**
     * 
     * @type {string}
     * @memberof Register
     */
    password2: string;
}

/**
 * Check if a given object implements the Register interface.
 */
export function instanceOfRegister(value: object): value is Register {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password1' in value) || value['password1'] === undefined) return false;
    if (!('password2' in value) || value['password2'] === undefined) return false;
    return true;
}

export function RegisterFromJSON(json: any): Register {
    return RegisterFromJSONTyped(json, false);
}

export function RegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): Register {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'],
        'password1': json['password1'],
        'password2': json['password2'],
    };
}

  export function RegisterToJSON(json: any): Register {
      return RegisterToJSONTyped(json, false);
  }

  export function RegisterToJSONTyped(value?: Register | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'password1': value['password1'],
        'password2': value['password2'],
    };
}

